
document.addEventListener('DOMContentLoaded', function() {
      const sizeGuide = document.querySelector('popup-size-guide');
      if (!sizeGuide) return;

      const select = sizeGuide.querySelector('.content-area__select');
      const img = sizeGuide.querySelector('.image-area > img');
      const widthEl = sizeGuide.querySelector('.content-area__value[type="width"]');
      const heightEl = sizeGuide.querySelector('.content-area__value[type="height"]');
      const shownAtEl = sizeGuide.querySelector('.content-area__value[type="shownAt"]');

      function updateValues() {
        if (!select || !select.options.length) return;
        const option = select.options[select.selectedIndex];
        img.src = option.getAttribute('img') || '';
        widthEl.textContent = option.getAttribute('width') || '—';
        heightEl.textContent = option.getAttribute('height') || '—';
        shownAtEl.textContent = option.getAttribute('shown-at') || '—';
      }

      // Run on initial load
      updateValues();

      // Update on dropdown change
      select.addEventListener('change', updateValues);

      // Open popup
      document.querySelectorAll('a.size-guide-trigger').forEach(trigger => {
        trigger.addEventListener('click', e => {
          e.preventDefault();
          document.body.classList.add('setOverlay');
          sizeGuide.classList.remove('hidden');
          select.disabled = false;
          updateValues();
        });
      });

      // Close popup on click
      sizeGuide.addEventListener('click', e => {
        if (e.target.closest('popup-close')) {
          document.body.classList.remove('setOverlay');
          sizeGuide.classList.add('hidden');
        }
      });
    });
    